<template>
  <div class="transfer-sensor-data">
    <h3 class="title">Перенос данных:</h3>

    <div class="transfer-container">
      <div class="transfer-section">
        <h4 class="section-title">Источник данных</h4>
        <el-select class="sensor-select" v-model="sourceSensor" placeholder="Выберите датчик-источник" size="large">
          <el-option v-for="sensor in currentSensors" :key="sensor.id_sensor" :label="sensor.name"
            :value="sensor.mac" />
        </el-select>
      </div>

      <div class="transfer-arrow">
        <i class="el-icon-right"></i>
      </div>

      <div class="transfer-section">
        <h4 class="section-title">Приёмник данных</h4>
        <el-select class="sensor-select" v-model="targetSensor" placeholder="Выберите датчик-приёмник" size="large">
          <el-option v-for="sensor in currentSensors" :key="sensor.id_sensor" :label="sensor.name"
            :value="sensor.mac" />
        </el-select>
      </div>
    </div>

    <button @click="postData" class="transfer-button" type="primary" icon="el-icon-right"
      :disabled="!sourceSensor || !targetSensor">
      Перенести
    </button>
  </div>
</template>

<script>
import { ElMessage } from 'element-plus';
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'TransferSensorData',
  props: ['name', 'sensors', 'companyId'],
  data() {
    return {
      currentSensors: [],
      sourceSensor: '',
      targetSensor: ''
    }
  },
  computed: {
  },
  methods: {
    ...mapActions('sensors', {
      chageSensorsInfo: 'chageSensorsInfo'
    }),
    postData() {
      try {
        if (this.sourceSensor === this.targetSensor) {
          ElMessage.error(`Не удалось перенести данные: источник и приемник один и тот же датчик`)
          return
        }
        this.chageSensorsInfo({ macFrom: this.sourceSensor, macTo: this.targetSensor })
        ElMessage.success('Данные перенесены')
      } catch (error) {
        ElMessage.error(`Не удалось перенести данные`)
      }
      // console.log(this.sourceSensor, this.targetSensor)
    },

    getSensors(obj) {
      const result = Object.values(obj)
        .flatMap(company => company.sensors)
        .map(sensor => ({
          mac: sensor.MAC,
          company_id: sensor.company_id,
          ...(sensor.name && { name: sensor.name })
        })).filter(sensor => sensor.company_id === this.companyId)

      return result
    }
  },
  watch: {
    companyId(newValue) {
      this.currentSensors = this.getSensors(this.sensors)
    }
  },
  created() {
    this.currentSensors = this.getSensors(this.sensors)
  }
}
</script>

<style scoped>
.transfer-sensor-data {
  display: flex;
  flex-direction: column;

  width: 100%;
  max-width: 900px;
  margin-left: 25px;
  margin-top: 25px;
  padding-right: 48px;
  border-radius: 12px;
  /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); */
}

.title {
  font-family: Lato;
  font-size: 14px;
  font-weight: 400;
  color: #333;
  margin-bottom: 25px;

}

.transfer-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 25px;
}

.transfer-section {
  flex: 1;
  padding: 15px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  background: #fafafa;
}

.section-title {
  font-size: 14px;
  color: #666;
  margin-bottom: 15px;
  text-align: center;
}

.sensor-select {
  width: 100%;
}

.transfer-arrow {
  padding: 0 20px;
  font-size: 24px;
  color: #409EFF;
}

.transfer-button {
  border-radius: 8px;
  background: var(--background-blue);
  color: #fff;
  padding: 6px 40px;

  margin-left: auto;
  transition: all 0.1s ease;
}

.transfer-button:hover {
  background: rgba(63, 81, 181, 0.8156862745);
}

.transfer-button:active {

  background: #3f51b55e;

}

.transfer-button[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
